function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.833 3a2.167 2.167 0 110 4.333 2.167 2.167 0 010-4.333zM11 5.167a3.167 3.167 0 10-6.333 0 3.167 3.167 0 006.333 0zM11.43 10.983a10.696 10.696 0 00-7.195 0 .857.857 0 00-.569.807v.877a.8.8 0 00.915.793l.636-.091a18.501 18.501 0 015.233 0l.636.09a.8.8 0 00.914-.792v-.877a.857.857 0 00-.57-.807zM3.9 10.04a11.697 11.697 0 017.867 0c.74.264 1.233.964 1.233 1.749v.877a1.8 1.8 0 01-2.056 1.783l-.636-.091a17.5 17.5 0 00-4.95 0l-.636.09a1.8 1.8 0 01-2.056-1.782v-.877c0-.785.494-1.485 1.233-1.75z",
  fill: "#B0B8CE"
});

function SvgAcc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
}

export default SvgAcc;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/Acc.svg
// module id = 1319
// module chunks = 10